<script>
import Translatable from '@src/mixins/translatable.js'
import SanitizerMixin from '@src/mixins/sanitizer-mixin.js'
import ImageMixin from '@src/mixins/imageMixin.js'
import Resizable from '@src/mixins/resizable.js'

export default {
  props: {
    card: {
      type: Object,
      required: true
    }
  },
  mixins: [
    Translatable,
    ImageMixin,
    SanitizerMixin,
    Resizable
  ],
  methods: {
    handleHover(event) {
      const popupContent = event.currentTarget.querySelector('.popup-content')
      const content = event.currentTarget.querySelector('.content')
      popupContent.classList.toggle('active')
      popupContent.classList.toggle('hidden')
      content.classList.toggle('active')
      content.classList.toggle('hidden')
    },
    handleClick(event) {
      const btn = event.currentTarget.querySelector('.see-all-btn')
      btn.classList.toggle('non-active')
    },
  },
}
</script>

<template>
  <div class="card" @mouseenter="handleHover" @mouseleave="handleHover" :style="getBackgroundSmall(card.image[1])">
    <div class="content active">
      <div class="exclusive-offer-btn">
        <p class="offer-text">
          {{ card.title }}
        </p>
      </div>
    </div>
    <div class="popup-content hidden">
      <div class="text-container">
        <div class="title" v-html="card.title">
        </div>
        <div class="popup-text" v-html="textSanitize(card.text)">
        </div>
      </div>
      <div @click="handleClick" class="see-all-wrapper">
        <a :href="card.route" class="see-all-btn" :class="!desktopScreen && 'non-active'">
          <button class="button-send">{{ card.btnText }}</button>
        </a>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.link {
  display: block;
  outline: none;
  width: 100%;
  height: 100%;
}

.see-all-wrapper {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  height: 100%;
  margin-bottom: 40px;

  .see-all-btn {
    min-width: 80px;
    width: auto;
    height: 40px;
    text-decoration: none;

    &.non-active {
      pointer-events: none;
    }
  }

  .button-send {
    min-width: 126px;
    width: auto;
    height: 40px;
    margin-top: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Open Sans Semibold, sans-serif;
    font-weight: 600;
    cursor: pointer;
    color: $white;
    border: 1px solid $orange;
    line-height: 35px;
    font-weight: bold;
    font-size: 15px;
    background: $orange;
    box-sizing: border-box;
    border-radius: 5px;
    text-decoration: none;
    text-transform: uppercase;
    padding: 0 20px;

    &:hover {
      background: $hover-orange;
      border: 1px solid $hover-orange;
    }
  }
}

.card {
  background-size: cover;
  position: relative;
  cursor: pointer;
  width: 560px;
  height: 300px;
  border-radius: 10px;
}

.content {
  position: absolute;
  display: grid;
  justify-items: center;
  height: 0;
  width: 100%;
}

.popup-content {
  display: flex;
  flex-direction: column;
  position: absolute;
  height: 0;
  width: 100%;
  border-radius: 10px;
  background-color: rgb(37, 44, 62, 0.85);
}

.active {
  height: 100%;
}

.hidden {
  display: none !important;
  visibility: hidden;
}

.exclusive-offer-btn {
  display: grid;
  align-content: center;
  justify-items: center;
  background: rgba(218, 75, 7, 0.7);
  border-radius: 10px;
}

.offer-text {
  font-family: Open Sans Bold, sans-serif;
  font-weight: bold;
  font-size: 18px;
  line-height: 23px;
  text-transform: uppercase;
  color: #FFFFFF;
}

.title {
  font-family: Open Sans Bold, sans-serif;
  font-weight: bold;
  font-style: normal;
  font-size: 18px;
  line-height: 25px;
  color: #FFFFFF;
  text-transform: uppercase;
}

.popup-text {
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  color: #FFFFFF;
  margin-top: 15px;
}

.exclusive-offer-btn {
  width: 476px;
  height: 71px;
  text-align: center;
  padding: 0 15px;
  margin-top: 208px;
}

.text-container {
  padding: 0 47px;
}

::v-deep.title, ::v-deep.popup-text {
  user-select: none;

  & em {
    font-style: italic;
  }

  & a {
    color: $gray;
    text-decoration: none;

    &:hover {
      color: $orange;
    }
  }

  & ul {
    margin-left: 20px;
    list-style: initial;
  }

  & strong {
    font-family: Open Sans Bold, sans-serif;
    font-style: normal;
    font-weight: bold;
  }

  & .ql-align-center {
    text-align: center;
  }
}

.title {
  margin-top: 30px;
}

@media only screen and (min-width: $mobile-screen-width) and (max-width: $container-width-xs) {
  .exclusive-offer-btn {
    margin-top: auto;
    margin-bottom: 28px;
    width: 260px;
    height: 59px;
  }

  .text-container {
    padding: 0 22px;
  }

  .popup-text {
    font-family: Open Sans, sans-serif;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    margin-top: 17px;
  }

  .title {
    margin-top: 33px;
  }

  .card, .popup-content {
    border-radius: 0;
  }
}
</style>
